import { render } from "./Mapfake3.vue?vue&type=template&id=6efd553a&bindings={}"
import script from "./Mapfake3.vue?vue&type=script&lang=js"
export * from "./Mapfake3.vue?vue&type=script&lang=js"

import "./Mapfake3.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script